import { Dialog } from '@headlessui/react';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useTranslation from '../../../../../hooks/useTranslations';
import { closeEvaluationErrorModal, openEvaluationErrorModal, selectEvaluationErrorModalIsOpen } from '../../../../../redux/modules/evaluationsSlice';
import ModalWrapper from '../../../layouts/partials/ModalWrapper';

const ErrorEvaluationModal = () => {
	const t = useTranslation();
	const dispatch = useDispatch();

	const isEvaluationModalOpen = useSelector((state) => (selectEvaluationErrorModalIsOpen(state)));

	const setIsModalOpen = useCallback((shouldOpen) => {
		if (shouldOpen) {
			dispatch(openEvaluationErrorModal());
		} else {
			dispatch(closeEvaluationErrorModal());
		}
	}, [dispatch]);

	return (
		<ModalWrapper isModalOpen={isEvaluationModalOpen} setIsModalOpen={setIsModalOpen} maxWidth="max-w-sm">
			<Dialog.Title
				as="h3"
				className="text-[1.25rem] font-semibold text-oly-gray-darkest text-center mb-4"
			>
				{t('eval_app_form_error_alert_title')}
			</Dialog.Title>
			<Dialog.Description
				as="p"
				className="text-[1.0625rem] text-oly-gray-darkest text-center mb-8 leading-6"
			>
				{t('eval_app_form_error_alert_message')}
			</Dialog.Description>
			<div className="flex -mx-6 border-t divide-x border-oly-gray-lightest divide-oly-gray-lightest">
				<button
					type="button"
					className="text-left flex-1 h-16 inline-flex justify-center items-center flex-grow px-4 py-2 text-[0.9375rem] font-normal text-oly-blue-dark can-hover:hover:bg-oly-gray-lightestAlpha45 focus-visible:bg-oly-gray-lightestAlpha45 focus:outline-none"
					onClick={() => setIsModalOpen(false)}
				>
					{t('general_ok')}
				</button>
			</div>
		</ModalWrapper>
	);
};

export default ErrorEvaluationModal;
